import React from "react";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { startCase } from "lodash";

const SectionHeader:React.FC<{ title: string, description: string }> =
({ title, description }) => (
  <Grid size={{ xs: 12 }}>
    <Typography variant="h6">{startCase(title)}</Typography>
    <Typography paragraph>{description}</Typography>
    <hr />
  </Grid>
);

export default SectionHeader;
